import React, { type JSX } from "react";
import { useFormContext } from "react-hook-form";
import { Dialog, Form } from "@sscs/ui";
import { extractFormFieldError } from "@sscs/utils";
import {
  SharedReportLinkRecipient,
  SharedReportPreviousRecipientsForm,
} from "../../../../../types";
import SelectableRecipientsTable from "../RecipientsTable/SelectableRecipientsTable";

type PreviousRecipientsStepProps = {
  initialPreviousRecipients: {
    email: SharedReportLinkRecipient["email"];
    lastOpened: SharedReportLinkRecipient["last_opened"];
    isSelected: boolean;
  }[];
};

const PreviousRecipientsStep = ({
  initialPreviousRecipients,
}: PreviousRecipientsStepProps): JSX.Element => {
  const formMethods = useFormContext<SharedReportPreviousRecipientsForm>();

  const { setValue, watch, formState } = formMethods;
  const { errorMessage, hasError } = extractFormFieldError(
    "recipients",
    formState.errors,
  );

  const selectedRecipientEmails = watch("recipients") ?? [];

  const allPreviousRecipients = initialPreviousRecipients.map((recipient) => ({
    email: recipient.email,
    last_opened: recipient.lastOpened,
  }));

  const onChangeRecipients = (newSelectedRecipients: string[]) => {
    setValue("recipients", newSelectedRecipients);
  };

  return (
    <Dialog.Section>
      <Dialog.Section.Title>
        Add from previous recipients (Optional)
      </Dialog.Section.Title>
      <Dialog.Section.Content>
        <SelectableRecipientsTable
          recipients={allPreviousRecipients}
          selectedRecipientEmails={selectedRecipientEmails}
          onChangeRecipients={onChangeRecipients}
        />
        <Form.HelperText error={hasError}>{errorMessage}</Form.HelperText>
      </Dialog.Section.Content>
    </Dialog.Section>
  );
};

export default PreviousRecipientsStep;
